var SIZES = {
  MAIN_BORDER_RADIUS: '.5rem',
  FIELD_WIDTH: '172px'
};
export { SIZES };